import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";

function AuthShell({ children }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-white">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <img src="/cesco-logo.png" alt="Cesco Equipment" className="w-40 h-40 object-contain" />
          <div className="mt-4 text-center">
            <div className="text-gray-900 text-2xl font-bold tracking-tight">CESCO</div>
            <div className="text-gray-500 text-xs tracking-[0.25em] mt-1">EQUIPMENT CRM</div>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  async function onSubmit(e) {
    e.preventDefault(); setErr(""); setMsg("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setMsg("If that email exists, a reset link has been sent. Check your inbox (and spam folder).");
    } catch(e) {
      const status = e.response?.status;
      if (status === 429) {
        setErr("Too many reset requests from this network. Please try again in 15 minutes.");
      } else {
        setErr(formatApiError(e.response?.data?.detail) || e.message || "Could not send reset link. Please try again.");
      }
    }
  }
  return (
    <AuthShell>
      <form onSubmit={onSubmit} className="bg-white rounded-2xl p-6 border border-[var(--cesco-border)] shadow-sm space-y-4"
            data-testid="forgot-form">
        <h1 className="text-xl font-bold">Reset password</h1>
        <p className="text-sm text-gray-600">We'll email you a reset link.</p>
        <div>
          <label className="cesco-label">Email</label>
          <input className="cesco-input" type="email" value={email} required
                 onChange={e=>setEmail(e.target.value)} data-testid="forgot-email"/>
        </div>
        {msg && <div className="text-sm text-green-700" data-testid="forgot-msg">{msg}</div>}
        {err && <div className="text-sm text-red-600">{err}</div>}
        <button className="cesco-btn-primary w-full" type="submit"
                data-testid="forgot-submit">Send reset link</button>
        <div className="text-center text-sm"><Link to="/login" className="text-gray-600">← Back to login</Link></div>
      </form>
    </AuthShell>
  );
}

export function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [ok, setOk] = useState(false);
  const nav = useNavigate();
  async function onSubmit(e) {
    e.preventDefault(); setErr("");
    if (pw.length < 8) { setErr("Password must be at least 8 characters"); return; }
    if (pw !== pw2) { setErr("Passwords do not match"); return; }
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setOk(true);
      setTimeout(()=>nav("/login"), 1500);
    } catch(e) { setErr(formatApiError(e.response?.data?.detail) || e.message); }
  }
  return (
    <AuthShell>
      <form onSubmit={onSubmit} className="bg-white rounded-2xl p-6 border border-[var(--cesco-border)] shadow-sm space-y-4"
            data-testid="reset-form">
        <h1 className="text-xl font-bold">Set a new password</h1>
        <input className="cesco-input" type="password" placeholder="New password" value={pw}
               onChange={e=>setPw(e.target.value)} required data-testid="reset-pw"/>
        <input className="cesco-input" type="password" placeholder="Confirm password" value={pw2}
               onChange={e=>setPw2(e.target.value)} required data-testid="reset-pw2"/>
        {err && <div className="text-sm text-red-600">{err}</div>}
        {ok && <div className="text-sm text-green-700">Updated - redirecting…</div>}
        <button className="cesco-btn-primary w-full" type="submit"
                data-testid="reset-submit">Update password</button>
      </form>
    </AuthShell>
  );
}
